var map = {
	"./image001.png": 1389,
	"./image002.png": 134,
	"./image003.png": 7539,
	"./image004.png": 9770,
	"./image005.png": 4645,
	"./image006.png": 1803,
	"./image007.png": 824,
	"./image009.png": 1229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9215;